var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasElos)?_c('div',{staticClass:"sub-domain-list-card card"},[_c('div',{staticClass:"sub-domain-header card-divider"},[_c('span',{staticClass:"grid-y cell auto"},[_vm._v(_vm._s(_vm._f("labelize")(_vm.subDomain.subDomainName))+" ")])]),_c('div',{staticClass:"sub-domain-body"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }